import React, { PureComponent } from 'react'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import InputText from '../../commons/form/InputText'
import { getListOusFromTree } from '../../../util/utils'
import ModalMassUploadPage from '../../../containers/masters/ModalMassUpload/ModalMassUploadPage'
import { loadTemplatesNames } from '../../../constants/backendIds'
import InputSelect from '../../commons/form/InputSelect'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import IDocCarPagination from '../../commons/iDocCarPagination'
import OrganizedUnitModalPage from '../../../containers/masters/OrganizedUnit/OrganizedUnitModalPage'
import MapSectionsMasters from '../../../util/map-sections-masters'

class OuLoad extends PureComponent {
  constructor () {
    super()
    this.state = {
      uoId: null,
      uoList: null,
      showModal: false,
      filter: {
        searchUo: 0,
        searchLegalCompany: 0,
        searchName: null,
        searchCode: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchOrganizedUnitList(null)
    this.props.actions.fetchOrganizedUnitsAll()
    this.props.actions.fetchDirectionOUCombo()
    this.props.actions.fetchLegalCompanyCombo()
    this.props.actions.fetchCountries()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchOrganizedUnitList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchOrganizedUnitList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleUoChange (searchUo) {
    if (this.state.filter.searchUo !== searchUo) {
      this.setState({ filter: { ...this.state.filter, searchUo }, uoId: searchUo })
    }
  }

  handleLegalCompanyChange (searchLegalCompany) {
    if (this.state.filter.searchLegalCompany !== searchLegalCompany) {
      this.setState({ filter: { ...this.state.filter, searchLegalCompany } })
    }
  }

  handleNameChange (searchName) {
    if (this.state.filter.searchName !== searchName) {
      this.setState({ filter: { ...this.state.filter, searchName } })
    }
  }

  handleCodeChange (searchCode) {
    if (this.state.filter.searchCode !== searchCode) {
      this.setState({ filter: { ...this.state.filter, searchCode } })
    }
  }

  searchOrganizedUnitList () {
    this.props.actions.fetchOrganizedUnitList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  handleOrganizedUnitChange (uoId) {
    let uoList = getListOusFromTree(this.props.combos.UOTreeCombo, uoId)
    this.setState({ uoId, uoList })
  }

  handleParamConfig (uoId) {
    this.props.actions.setChangeTabFromConfMaster(uoId, true)
  }

  handleRecurrentEntity (uoId) {
    this.props.actions.setChangeTabFromMaster(uoId, true)
  }

  openOuModalLoad () {
    this.setState({ showModal: true })
    this.props.actions.openModalMass('MASTERS.OU_MASTERS.', this.props.actions.uploadUoMassDocument, this.props.actions.fetchOrganizedUnitsTree)
  }

  closeOuModalLoad () {
    this.setState({ showModal: false })
  }

  resetFilters () {
    this.setState({
      filter: {
        searchUo: 0,
        searchLegalCompany: 0,
        searchName: null,
        searchCode: null
      }
    }, () => { this.searchOrganizedUnitList() })
  }

  render () {
    const {
      t, organizedUnitList, organizedUnitCount, pagesCount, filter, selectSection,
      filter: { page },
      actions: { fetchTemplateFile, fetchOrganizedUnitList, openOrganizedUnitModal },
      combos: { UOTreeCombo, legalCompanyCombo }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'organizedUnitMasterUploadPage' })
    const tKey = 'MASTERS.OU_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const recurrentEntityTooltip = (<Tooltip id="recurrentEntityTooltip">{t('ADMIN.RECURRENT_ENTITIES_TITLE')}</Tooltip>)
    const paramConfigTooltip = (<Tooltip id="paramConfigTooltip">{t('MASTERS.ORGANIZED_UNIT_CONFIGURATION')}</Tooltip>)
    const downloadTemplateTooltip = (<Tooltip id="userTooltip">{t('MASTERS.DOWNLOAD')}</Tooltip>)
    const uiploadTemplateTooltip = (<Tooltip id="editProductTooltip">{' ' + t(`${tKey}UPLOAD_DOCUMENT`)}</Tooltip>)

    const hasFilters = (this.state.filter.searchCode || this.state.filter.searchLegalCompany || this.state.filter.searchName || this.state.filter.searchUo)

    return (
      <div id="ouLoad" className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openOrganizedUnitModal()}>
              <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>
            <OverlayTrigger placement="left" overlay={downloadTemplateTooltip}>
              <Button
                className="_Btn accent o-icn"
                onClick={() => fetchTemplateFile(loadTemplatesNames.orgUnit)}>
                <i className='iDocIcon-download'></i>
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="left" overlay={uiploadTemplateTooltip}>
              <Button
                className="_Btn new o-icn"
                onClick={this.openOuModalLoad.bind(this)}>
                <i className='iDocIcon-file-excel' />
              </Button>
            </OverlayTrigger>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputTreeSelect}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                name="filters.organizedUnitIdd"
                controlLabel={t(`${tKey}ORGANIZED_UNIT`)}
                placeholder={t(`${tKey}ORGANIZED_UNIT`)}
                valueKey="value"
                labelKey="label"
                childrenKey="children"
                options={UOTreeCombo}
                onInputChange={(value) => this.handleUoChange(value)}
                showSearch={false}
              />
              <Field
                component={InputText}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                name="filters.code"
                controlLabel={t(`${tKey}UOCODE`)}
                placeholder={t(`${tKey}UOCODE`)}
                onInputChange={(value) => this.handleCodeChange(value)}
              />
              <Field
                component={InputText}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                name="filters.name"
                controlLabel={t(`${tKey}NAME`)}
                placeholder={t(`${tKey}NAME`)}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                component={InputSelect}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                name="filters.legalCompanyId"
                controlLabel={t(`${tKey}LEGAL_COMPANY`)}
                placeholder={t(`${tKey}LEGAL_COMPANY`)}
                options={legalCompanyCombo}
                valueKey="id"
                labelKey="value"
                searchPlaceholder={t(`${tKey}LEGAL_COMPANY`)}
                onInputChange={(value) => this.handleLegalCompanyChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchOrganizedUnitList()}
                  // </div>onKeyDown={(e) => handleKeyDown(e)}
                >
                  <i className="ico-search" />
                  {t('ADMIN.SEARCH_BTN')}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(organizedUnitList.length !== 0) &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th
                        onClick={() => { this.changeOrder('organizedUnitId') }}
                      >
                        {t('MASTERS.ID')}
                        <i className={this.getSortIcon(t('MASTERS.ID'))} />
                      </th>
                      <th
                        onClick={() => { this.changeOrder('code') }}
                      >
                        {t(`${tKey}UOCODE`)}
                        <i className={this.getSortIcon(t(`${tKey}UOCODE`))} />
                      </th>
                      <th
                        onClick={() => { this.changeOrder('name') }}
                      >
                        {t(`${tKey}NAME`)}
                        <i className={this.getSortIcon(t(`${tKey}NAME`))} />
                      </th>
                      <th
                        onClick={() => { this.changeOrder('parentOrganizedUnit') }}
                      >
                        {t(`${tKey}PARENT_OU`)}
                        <i className={this.getSortIcon(t(`${tKey}PARENT_OU`))} />
                      </th>
                      <th
                        onClick={() => { this.changeOrder('brand') }}
                      >
                        {t(`${tKey}BRAND`)}
                        <i className={this.getSortIcon(t(`${tKey}BRAND`))} />
                      </th>
                      <th
                        onClick={() => { this.changeOrder('legalCompany') }}
                      >
                        {t(`${tKey}LEGAL_COMPANY`)}
                        <i className={this.getSortIcon(t(`${tKey}LEGAL_COMPANY`))} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {organizedUnitList && organizedUnitList.map((ou, idx) => (
                      <tr key={idx}>
                        <td>{ou.organizedUnitId}</td>
                        <td>{ou.code}</td>
                        <td>{ou.name}</td>
                        <td>{ou.parentOrganizedUnit?.name}</td>
                        <td>{ou.brand}</td>
                        <td>
                          {
                            ou.legalCompany?.cif && ou.legalCompany?.description
                              ? ou.legalCompany?.cif + ' - ' + ou.legalCompany?.description
                              : ou.legalCompany?.cif ?? ou.legalCompany?.description
                          }
                        </td>
                        <td className='actions'>
                          <div>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <a className='_Btn accept stk o-icn ' onClick={() => openOrganizedUnitModal(ou.organizedUnitId)}>
                                <i className="iDocIcon-edit" />
                              </a>
                            </OverlayTrigger>
                            <OverlayTrigger placement="left" overlay={recurrentEntityTooltip}>
                              <Button className="_Btn accept stk o-icn " onClick={() => { selectSection('adminRecurrentEntities'); this.handleRecurrentEntity(ou.organizedUnitId) } }>
                                <i className="iDocIcon-user-user-menu"/>
                              </Button>
                            </OverlayTrigger>
                            <OverlayTrigger placement="left" overlay={paramConfigTooltip}>
                              <Button className="_Btn accept stk o-icn " onClick={() => { selectSection('organizedUnitConfigurationMaster'); this.handleParamConfig(ou.organizedUnitId) } }>
                                <i className="iDocIcon-optionals"/>
                              </Button>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    ))}

                  </tbody>
                </Table>
              }
              {(organizedUnitList === null || organizedUnitList === undefined || organizedUnitList.length === 0) &&
              <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_organized_unit"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={organizedUnitCount}
                    onSelectAction={(value) => fetchOrganizedUnitList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <OrganizedUnitModalPage />
        <ModalMassUploadPage
          showModal={this.state.showModal}
          closeModal={this.closeOuModalLoad.bind(this)}
        />
      </div>
    )
  }
}

export default reduxForm({
  form: 'listOrganizedUnit'
})(OuLoad)
